// extracted by mini-css-extract-plugin
export var button_icon = "login-module--button_icon--ZwH5H";
export var chosed_role = "login-module--chosed_role--vXeCI";
export var footer_form = "login-module--footer_form--9j6k8";
export var forgot_button = "login-module--forgot_button--Edjvv";
export var form_wrapper = "login-module--form_wrapper--Brfpg";
export var modal_button = "login-module--modal_button--ePlZM";
export var recover_description = "login-module--recover_description--9RXWd";
export var social_btn = "login-module--social_btn---GpLn";
export var social_btn__apple = "login-module--social_btn__apple--VPWIo";
export var social_btn__fb = "login-module--social_btn__fb--4lgem";
export var social_btn__google = "login-module--social_btn__google--B5mRN";
export var social_links_wrap = "login-module--social_links_wrap--lTRPd";